import { useEffect } from "react";
import { MessageCircle, ShieldCheck, Sparkles } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { api, openChat } from "../lib/api";
import { Logo } from "../components/site/Logo";

export const VisitorPing = () => {
  useEffect(() => {
    if (sessionStorage.getItem("wouffa_pinged")) return;
    sessionStorage.setItem("wouffa_pinged", "1");
    let browser_id = localStorage.getItem("wouffa_browser_id");
    if (!browser_id) {
      browser_id = "b-" + Math.random().toString(36).slice(2) + Date.now().toString(36);
      localStorage.setItem("wouffa_browser_id", browser_id);
    }
    api.post("/visitors/ping", { browser_id, referrer: document.referrer || "" }).catch(() => {});
  }, []);
  return null;
};

export default function Wengo() {
  const navigate = useNavigate();
  useEffect(() => {
    const t = setTimeout(() => openChat(), 900);
    return () => clearTimeout(t);
  }, []);
  return (
    <div className="flex min-h-[100svh] flex-col items-center justify-center bg-[#0a0908] px-5 text-center" data-testid="wengo-page">
      <VisitorPing />
      <Logo size={72} />
      <h1 className="mt-6 font-display text-3xl text-amber-50">Wengo</h1>
      <p className="mt-3 max-w-sm text-sm leading-relaxed text-stone-300">
        Vous venez de la page Wengo ? Le Maître Wouffa vous reçoit en consultation directe, en toute discrétion.
      </p>
      <button onClick={() => openChat()} data-testid="wengo-chat-button"
        className="mt-10 flex items-center gap-3 rounded-full bg-amber-400 px-9 py-4 text-sm font-bold uppercase tracking-[0.15em] text-stone-950 transition-transform duration-300 hover:scale-[1.03] active:scale-95">
        <MessageCircle className="h-4 w-4" /> Écrire au Maître maintenant
      </button>
      <div className="mt-10 flex flex-col items-center gap-3 text-xs text-stone-400">
        <span className="flex items-center gap-2"><ShieldCheck className="h-4 w-4 text-amber-400" /> Paiement uniquement après satisfaction</span>
        <span className="flex items-center gap-2"><Sparkles className="h-4 w-4 text-amber-400" /> 150€ · Voyance 30€ · Travaux 50€</span>
      </div>
      <button onClick={() => navigate("/")} data-testid="wengo-back-site"
        className="mt-12 text-xs uppercase tracking-[0.2em] text-stone-400 hover:text-amber-300">
        Voir le site complet
      </button>
    </div>
  );
}
